module.exports = __webpack_public_path__ + "static/img/14000615.53a0393a.png";